//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { TrackingId } from '@models/TrackingId';

export enum OnboardingCatalogType {
  GOOGLE = 'GOOGLE',
  MAGENTO = 'MAGENTO',
  OTHER = 'OTHER',
  SHOPIFY = 'SHOPIFY',
}

export interface OnboardingStepInfo {
  status: OnboardingStepStatus;
  isError: boolean;
  isPending: boolean;
}

export enum OnboardingStepStatus {
  INCOMPLETE = 'incomplete',
  COMPLETE = 'complete',
  PENDING = 'pending',
}

export const TrackingIdPrefix = 'onboarding-';

export const ONBOARDING_STEP_ICON_SIZE = '24px';

export const ONBOARDING_TRACKING_ID = {
  RESOURCES_GETTING_STARTED_ARTICLE_ANCHOR: `${TrackingIdPrefix}resources-getting-started-article-anchor`,
  RESOURCES_KNOWLEDGE_BASE_ANCHOR: `${TrackingIdPrefix}resources-knowledge-base-anchor`,
  RESOURCES_OVERVIEW_BAZAARVOICE_UNIVERSITY_LINK: `${TrackingIdPrefix}resources-overview-bazaarvoice-university-link`,
  SPOTLIGHT_CREATOR_MARKETING_SEE_MORE_BUTTON: `${TrackingIdPrefix}spotlight-creator-marketing-see-more-button`,
  SPOTLIGHT_PRODUCT_SAMPLING_SEE_MORE_BUTTON: `${TrackingIdPrefix}spotlight-product-sampling-see-more-button`,
  SPOTLIGHT_SEE_ALL_RECENT_UPDATES_BUTTON: `${TrackingIdPrefix}spotlight-see-all-recent-updates-button`,
  SPOTLIGHT_SOCIAL_COMMERCE_SEE_MORE_BUTTON: `${TrackingIdPrefix}spotlight-social-commerce-see-more-button`,
  SPOTLIGHT_SOCIAL_MEDIA_MANAGEMENT_SEE_MORE_BUTTON: `${TrackingIdPrefix}spotlight-social-media-management-see-more-button`,
  SUPPORT_CONTACT_SUPPORT_BUTTON: `${TrackingIdPrefix}support-contact-support-button`,
  SUPPORT_KNOWLEDGE_BASE_ANCHOR: `${TrackingIdPrefix}support-knowledge-base-anchor`,
} as const satisfies Record<string, TrackingId>;
